export default "-- ClickBench Q6\nselect min(eventdate), max(eventdate)\nfrom hits;";